export enum InsightCalculatorGroup {
  Glucose = "glucoseCalculations",
  Quartile = "quartileCalculations",
  Exercise = "exerciseCalculations",
  Food = "foodCalculations",
  Insulin = "insulinCalculations",
  Liquid = "liquidCalculations",
  TimeInRange = "timeInRangeCalculation",
  None = "noCalculations",
}
